import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import R from 'ramda'
import {
  Button,
  Segment
} from 'semantic-ui-react'

const getId = R.prop('_id')
const getExpiresOn = R.compose(
  (exp) => `${moment(exp).calendar()},  ${moment(exp).fromNow()}`,
  R.prop('expires_on')
)
const getSerialNum = R.path(['details', 'serialnumber'])
// const getPlatform = R.path(['details', 'platform'])
const getOsVersion = R.path(['details', 'osversion'])
// const getOsName = R.path(['details', 'osname'])
const getMac = R.path(['details', 'mac'])
const getCpuVendor = R.path(['details', 'cpuvendor'])
const getCpuCount = R.path(['details', 'cpucount'])

const getTitledMeta = (title, getter) => R.ifElse(
  getter,
  m => (<div style={{display: 'inline-block', paddingRight: '2em'}}><b>{title}</b> : {getter(m)}</div>),
  m => null
)

const getIdComponent = getTitledMeta('Md5', getId)
const getExpiresOnComponent = getTitledMeta('Expires', getExpiresOn)
const getSerialNumComponent = getTitledMeta('Serial Number', getSerialNum)
// const getPlatformComponent = getTitledMeta('Platform', getPlatform)
const getOsVersionComponent = getTitledMeta('OS Version', getOsVersion)
// const getOsNameComponent = getTitledMeta('OS Name', getOsName)
const getMacComponent = getTitledMeta('Mac', getMac)
const getCpuVendorComponent = getTitledMeta('CPU Vendor', getCpuVendor)
const getCpuCountComponent = getTitledMeta('CPU Count', getCpuCount)

const confirmDelete = (onRemove, fieldName, objectId, machineId) => e => {
  if (window.confirm('Remove this machine?')) {
    console.log('removing machine', objectId, machineId)
    onRemove({[fieldName]: objectId, machineId})
  }
}

const Machine = ({
  machine,
  objectId,
  fieldName,
  onRemove
}) => (
  <Segment compact>
    <div style={{borderBottom: '1px solid grey', display: 'inline'}}>
      {getIdComponent(machine)}
      {getExpiresOnComponent(machine)}
    </div>
    <div>
      {getSerialNumComponent(machine)}
      {getOsVersionComponent(machine)}
      {getMacComponent(machine)}
      {getCpuVendorComponent(machine)}
      {getCpuCountComponent(machine)}
    </div>
    <Button negative content='Remove' size='mini' onClick={confirmDelete(onRemove, fieldName, objectId, machine._id)} />
  </Segment>
)
Machine.propTypes = {
  machine: PropTypes.object.isRequired,
  objectId: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired
}

const Machines = ({
  onRemoveMachine,
  objectId,
  fieldName,
  machines = []
}) => (
  <Segment.Group>
    {machines.map(machine => (<Machine key={getId(machine)} machine={machine} objectId={objectId} onRemove={onRemoveMachine} fieldName={fieldName} />))}
  </Segment.Group>
)
Machines.propTypes = {
  machines: PropTypes.array.isRequired,
  objectId: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  onRemoveMachine: PropTypes.func.isRequired
}

export default Machines



// WEBPACK FOOTER //
// ./webAdmin/views/machines.js